import { ScheduleApplicationListMilestone } from "@common/schemas/domains/accounting/scheduleApplicationList.schema";
import {
    ScheduleApplicationPeriodStatus,
    ScheduleApplicationStatus,
} from "@common/types/domains/accounting/schedule";

export function canMarkMilestoneAchieved(row: {
    milestone: ScheduleApplicationListMilestone | null;
    periodStatus: ScheduleApplicationPeriodStatus;
    applicationStatus: ScheduleApplicationStatus;
}): boolean {
    return (
        row.milestone !== null &&
        row.periodStatus === ScheduleApplicationPeriodStatus.pending &&
        row.applicationStatus === ScheduleApplicationStatus.active
    );
}

/**
 * A paused schedule holds every unconfirmed milestone until resume. Schedules
 * paused before overdue rows were held too still have those rows pending.
 */
export function isMilestoneOnHold(row: {
    periodStatus: ScheduleApplicationPeriodStatus;
    applicationStatus: ScheduleApplicationStatus;
}): boolean {
    return (
        row.periodStatus !== ScheduleApplicationPeriodStatus.posted &&
        row.applicationStatus === ScheduleApplicationStatus.paused
    );
}

export function buildUnpostedMilestoneDescription(options: {
    periodStatus: ScheduleApplicationPeriodStatus;
    applicationStatus: ScheduleApplicationStatus;
    milestone: Pick<ScheduleApplicationListMilestone, "sortOrder" | "name">;
}): string {
    const label = `Milestone ${options.milestone.sortOrder}: ${options.milestone.name}`;
    if (isMilestoneOnHold(options)) {
        return `${label} (paused)`;
    }
    if (options.periodStatus !== ScheduleApplicationPeriodStatus.voided) {
        return label;
    }
    return options.applicationStatus === ScheduleApplicationStatus.stopped
        ? `${label} (canceled)`
        : `${label} (voided)`;
}
